<template>
  <SingleSelect
    v-model="itemsSelected"
    :searchable="false"
    :items="selectItems"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    @clearClick="$emit('clearInfo', label)"
  >
    <template v-slot:selection="{item}">
      <span
        class="darkpost-filter__summary text--disabled"
      >
        {{ item.text }}
      </span>
    </template>
  </SingleSelect>
</template>

<script>
import SingleSelect from './models/SingleSelect';

export default {
  name: 'DarkPostFilter',
  components: {
    SingleSelect,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      placeholder: 'Todos',
      label: 'Tipo de Publicação',
      selectItems: [
        {
          text: 'Todos',
          value: '',
        },
        {
          text: 'Orgânico',
          value: false,
        },
        {
          text: 'Impulsionado',
          value: true,
        },
      ],
    };
  },
  computed: {
    itemsSelected: {
      get() {
        return this.value?.value;
      },
      set(newValue) {
        if (typeof newValue !== 'boolean') {
          return this.$emit('input', undefined);
        }
        this.$emit('input', {
          value: newValue,
        });
      },
    },
  },
};

</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }

  .darkpost-filter__summary {
    font-size: 13.333px;
  }
</style>
